import {
  formatBindingDateTime,
  translateBindingChannelStatus
} from './leadNotificationBindingDisplay.mjs';

function widenBindingDialog(width = '920px') {
  if (typeof document === 'undefined') return;
  const dialogs = Array.from(document.querySelectorAll('.el-dialog'));
  const target = dialogs.find((item) => {
    const title = item.querySelector('.el-dialog__title');
    const text = title && title.textContent ? title.textContent.trim() : '';
    return text === '绑定管理';
  });
  if (target) {
    target.style.width = width;
    target.style.maxWidth = '96vw';
  }
}

export function normalizeBindingList(list = []) {
  widenBindingDialog();
  return (Array.isArray(list) ? list : []).map((item) => ({
    ...item,
    wecomStatus: translateBindingChannelStatus('wecomStatus', item && item.wecomStatus),
    wechatNoticeStatus: translateBindingChannelStatus('wechatNoticeStatus', item && item.wechatNoticeStatus)
  }));
}

export function normalizeBindingPreview(preview = {}) {
  return {
    ...(preview && typeof preview === 'object' ? preview : {}),
    expiresAt: formatBindingDateTime(preview && preview.expiresAt)
  };
}
